import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { InfoCircleOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Table, Pagination, Modal, Space, Upload } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Filter from "../../components/filter/Filter";
import { deleteProduct, getProducts, importProducts } from "../../redux/slices/products/productsThunk";
import { toast } from "react-toastify";
import { columns } from "./columns";
import ImportComponent from "../../components/logModal";

const ProductPage = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState({
    searchTerm: "",
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
  });

    const [showLog, setShowLog] = useState(false);
  

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemId, setItemId] = useState(null);
  const history = useHistory();
  const products_data = useSelector((state) => state.products?.products?.data);
  const loading = useSelector((state) => state.products.products?.loading);
  const totalItems = useSelector((state) => state.products.products?.total);
  const loadingImportation = useSelector((state) => state.products?.importProducts.loading);

  const handlePagination = (page, pageSize) => {
    setPagination({ pageSize: pageSize, currentPage: page });
  };
  const navigateTo = (path) => {
    history.push(path);
  };

  const showModal = (id) => {
    setIsModalOpen(true);
    setItemId(id);
  };

  const handleDelete = (id) => {
    dispatch(deleteProduct(id)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        // Dispatch getProducts only once after successful deletion
        dispatch(getProducts(
          {
            page: pagination.currentPage,
            limit: pagination.pageSize,
            filter: {
              search: search.searchTerm
            }
          }
        ));

        toast.success("Produit supprimé avec succès!");
        navigateTo("/produit");
      } else {
        toast.error("Erreur pendant la suppression!");
      }
    }).catch(error => {
      // Handle any errors that might happen during the dispatch
      console.error(error);
      toast.error("Une erreur est survenue!");
    });

    setIsModalOpen(false); // Close the modal after the operation
  };

  useEffect(() => {
    dispatch(getProducts(
      {
        page: pagination.currentPage,
        limit: pagination.pageSize,
        filter: {
          search: search.searchTerm
        }
      }));
  }, [pagination, search, dispatch]);

  const handleSearchedValue = (value, key) => {
    if (search[key] !== value) {
      setSearch((prevSearch) => ({
        ...prevSearch,
        [key]: value,
      }));
      if (key === "searchTerm")
        setPagination((prevPagination) => ({
          ...prevPagination,
          currentPage: 1, // Reset page to 1 when filter changes
        }));
    }
  };

    const handleFileUpload = (file) => {
      const formData = new FormData();
      formData.append('file', file);
      dispatch(importProducts(formData))
        .then(response => {
          if (response.meta.requestStatus === "fulfilled") {
            toast.success('Fichier importé avec succès');
          }
        })
        .catch(error => {
          toast.error('Erreur lors de l\'importation du fichier', error);
        });
    };
    const handleShowLog = () => {
      setShowLog(!showLog)
    }
  
  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Liste des Produits"
            extra={
              <Space>
                <Button
                  shape="circle"
                  icon={
                    loadingImportation ? (
                      <InfoCircleOutlined style={{ color: 'orange' }} />
                    ) : (
                      <InfoCircleOutlined />
                    )
                  }
                  onClick={handleShowLog}
                />
                <Upload
                  accept=".csv"
                  customRequest={({ file, onSuccess, onError }) => {
                    handleFileUpload(file);
                    onSuccess();
                  }}
                  showUploadList={false}
                  disabled={loadingImportation}
                >
                  <Space />
                  <Button
                    type="primary"
                    icon={<UploadOutlined />}
                    loading={loadingImportation}
                  >
                    Importer
                  </Button>
                </Upload>
                <Button
                  type="primary"
                  onClick={() => history.push("/nouveau/produit")}
                >
                  <PlusOutlined />
                  Ajouter un produit
                </Button>
              </Space>

            }
          />
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={
              <Filter
                searchPlaceholder="Rechercher"
                onSearchValue={handleSearchedValue}
              />
            }
          >
            <Table
              columns={columns(history, showModal)}
              dataSource={products_data}
              className="ant-border-space"
              rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
              pagination={false}
              rowKey="id"
              loading={loading}
            />
          </Card>
          <Pagination
            current={pagination.currentPage}
            total={totalItems}
            pageSize={pagination.pageSize}
            onChange={handlePagination}
          />
        </Col>
        <Modal
          title="Supprimer un Produit"
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={[
            <Button key="back" onClick={() => setIsModalOpen(false)}>
              Annuler
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => handleDelete(itemId)}
            >
              Supprimer
            </Button>,
          ]}
        >
          <p>Êtes-vous sûr de vouloir supprimer ce produit ?</p>
        </Modal>
      </Row>
      <ImportComponent visible={showLog} onCancel={handleShowLog}></ImportComponent>
    </div>
  );
};

export default ProductPage;
